/**
 * SDK Initialization tracking event names
 * All event names should follow the pattern: sdk_init_*
 * But for backward compatibility with tests, we use the original names
 */

// SDK Initialization Events
export const SDK_INIT_MJS_LOAD_START = 'klarna_sdk_v1_mjs_sdk_load_start'
export const SDK_INIT_MJS_LOAD_END = 'klarna_sdk_v1_mjs_sdk_load_end'
export const SDK_INIT_JS_LOAD_START = 'klarna_sdk_v1_js_sdk_load_start'
export const SDK_INIT_JS_LOAD_END = 'klarna_sdk_v1_js_sdk_load_end'
export const SDK_INIT_JS_FETCH_SDK = 'klarna_sdk_v1_js_fetch_sdk'
export const SDK_INIT_JS_FETCH_RUNTIME_CONFIG = 'klarna_sdk_v1_js_fetch_runtime_config'
export const SDK_INIT_MJS_FETCH_RUNTIME_CONFIG = 'klarna_sdk_v1_mjs_fetch_runtime_config'
export const SDK_INIT_LOAD_ERROR = 'klarna_sdk_v1_load_error'
export const SDK_INIT_LOAD_RETRY = 'klarna_sdk_v1_load_retry'
export const SDK_INIT_MJS_LOAD_ERROR = 'klarna_sdk_v1_mjs_load_error'

// SDK Backend Bridge Initialization Events
export const SDK_INIT_BACKEND_BRIDGE = 'klarna_sdk_v1_initialize_backend_bridge'

// SDK Feature Initialization Events
export const SDK_INIT_METRIC = 'klarna_sdk_v1_metric_sdk_init'

// SDK Feature Initialization Error Events
export const SDK_INIT_SHOPPING_ERROR = 'klarna_sdk_v1_shopping_error'
export const SDK_INIT_INTEROPERABILITY_ERROR = 'klarna_sdk_v1_interoperability_error'
export const SDK_INIT_PAYMENT_ERROR = 'klarna_sdk_v1_payment_error'
export const SDK_INIT_IDENTITY_ERROR = 'klarna_sdk_v1_identity_error'
export const SDK_INIT_CONFIG_ERROR = 'klarna_sdk_v1_config_error'
export const SDK_INIT_MESSAGING_ERROR = 'klarna_sdk_v1_messaging_error'
export const SDK_INIT_RESUME_SESSION_ERROR = 'klarna_sdk_v1_resume_session_error'
export const SDK_INIT_RESUME_CURRENT_SESSION_ERROR = 'klarna_sdk_v1_resume_current_session_error'

// SDK Feature Performance Events
export const SDK_INIT_FEATURE_CONFIG = 'klarna_sdk_v1_initialize_config'
export const SDK_INIT_FEATURE_IDENTITY = 'klarna_sdk_v1_initialize_identity'
export const SDK_INIT_FEATURE_INTEROPERABILITY = 'klarna_sdk_v1_initialize_interoperability'
export const SDK_INIT_FEATURE_MESSAGING = 'klarna_sdk_v1_initialize_messaging'
export const SDK_INIT_FEATURE_PAYMENT = 'klarna_sdk_v1_initialize_payment'
export const SDK_INIT_FEATURE_SHOPPING = 'klarna_sdk_v1_initialize_shopping'
